module.exports = __webpack_public_path__ + "img/36000.2ea6e76d.jpg";